import { useState, useCallback, useEffect, useMemo } from 'react';
import { hasuraClient } from '../utils/graphqlClient';
import { GET_FIRM_DETAIL_QUERY } from '../graphql/queries/firms';
import { useAccessibleFirmIds } from './useAccessibleFirmIds';

export const useFirmDetail = firmId => {
  const { firmIds, loading: firmIdsLoading, isRestricted } = useAccessibleFirmIds();
  const [firm, setFirm] = useState(null);
  const [offers, setOffers] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDetail = useCallback(async () => {
    if (!firmId) return;
    try {
      setLoading(true);
      const result = await hasuraClient.query(GET_FIRM_DETAIL_QUERY, {
        id: parseInt(firmId),
      });
      setFirm(result.firms_by_pk || null);
      setOffers(result.offers || []);
      setInvoices(result.invoices || []);
    } catch (e) {
      console.error('Error fetching firm detail:', e);
    } finally {
      setLoading(false);
    }
  }, [firmId]);

  useEffect(() => {
    fetchDetail();
  }, [fetchDetail]);

  const accessDenied = useMemo(() => {
    if (!firm || !isRestricted || firmIdsLoading) return false;
    return !firmIds?.includes(parseInt(firmId));
  }, [firm, isRestricted, firmIdsLoading, firmIds, firmId]);

  return {
    firm,
    offers,
    invoices,
    loading: loading || (isRestricted && firmIdsLoading),
    refetch: fetchDetail,
    accessDenied,
  };
};
